import { zodResolver } from "@hookform/resolvers/zod";
import { t } from "@lingui/macro";
import { defaultSkill, skillSchema } from "@reactive-resume/schema";
import {
  Badge,
  BadgeInput,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Select,
  SelectItem,
  SelectContent,
  SelectTrigger,
  SelectValue,
  Slider,
} from "@reactive-resume/ui";
import { AnimatePresence, motion } from "framer-motion";
import { useState, useLayoutEffect, useEffect } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { axios } from "@/client/libs/axios";
import { SectionDialog } from "../sections/shared/section-dialog";
import { skillsListArr } from "../../../../../../../../apps/constants";

const formSchema = skillSchema;

type FormValues = z.infer<typeof formSchema>;
export const check_all = () => {
  // skillsListArr select array of skills
  const skillsList = skillsListArr.map(item => item.skills);
 
  const sresponse: any = skillsList;
  return sresponse;
};

export const SkillsDialog = () => {
  const form = useForm<FormValues>({
    defaultValues: defaultSkill,
    resolver: zodResolver(formSchema),
  });

  let [list1, setData]: any = useState([]);
  useLayoutEffect(() => {
    let Skills: any = [];
    let list2: any = [];
    // list1 = []
    // list2 = []
    // console.log("test>>>", list1, list1.length);

    // console.log('i fire once a');
    if (list1.length == 0) {
      const Skills = check_all();
      // let sresponse: any = check_all().then((response: any) => {
        // Skills = response.data;
        if (list1.length <= Skills.length) {
          // Skills = Array.from(new Set(Skills.map((item: any) => item)));
          // console.log("dsad", Skills)
          Skills.forEach((skill: any, i: any) => {
            list2.push(
              <SelectItem key={i} value={skill}>
                {skill}
              </SelectItem>,
            );
          });
          setData(list2);
        }
      // });
    }
  }, []);
  return (
    <SectionDialog<FormValues> id="skills" form={form} defaultValues={defaultSkill}>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <FormField
          name="name"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t`Skill`}</FormLabel>
              <FormControl>
                <Select
                  {...field}
                  value={field.value}
                  onValueChange={(value) => {
                    // console.log(value)
                    form.setValue("name", value);
                    form.clearErrors();
                  }}
                >
                  <SelectTrigger>
                    <SelectValue placeholder={field.value || "Select Skill"} />
                  </SelectTrigger>
                  <SelectContent>
                    <div className="scrollable-dropdown">{list1}</div>
                  </SelectContent>{" "}
                </Select>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          name="description"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t`Description`}</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          name="level"
          control={form.control}
          render={({ field }) => (
            <FormItem className="sm:col-span-2">
              <FormLabel>{t`Level`}</FormLabel>
              <FormControl className="py-2">
                <div className="flex items-center gap-x-4">
                  <Slider
                    {...field}
                    min={0}
                    max={5}
                    value={[field.value]}
                    orientation="horizontal"
                    onValueChange={(value) => field.onChange(value[0])}
                  />

                  {field.value === 0 ? (
                    <span className="text-base font-bold">{t`Hidden`}</span>
                  ) : (
                    <span className="text-base font-bold">{field.value}</span>
                  )}
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        {/* <FormField
          name="keywords"
          control={form.control}
          render={({ field }) => (
            <div className="space-y-3 sm:col-span-2">
              <FormItem>
                <FormLabel>{t`Keywords`}</FormLabel>
                <FormControl>
                  <BadgeInput {...field} setPendingKeyword={setPendingKeyword} />
                </FormControl>
                <FormDescription>
                  {t`You can add multiple keywords by separating them with a comma or pressing enter.`}
                </FormDescription>
                <FormMessage />
              </FormItem>

              <div className="flex flex-wrap items-center gap-x-2 gap-y-3">
                <AnimatePresence>
                  {field.value.map((item, index) => (
                    <motion.div
                      layout
                      key={item}
                      initial={{ opacity: 0, y: -50 }}
                      animate={{ opacity: 1, y: 0, transition: { delay: index * 0.1 } }}
                      exit={{ opacity: 0, x: -50 }}
                    >
                      <Badge
                        className="cursor-pointer"
                        onClick={() => {
                          field.onChange(field.value.filter((v) => item !== v));
                        }}
                      >
                        <span className="mr-1">{item}</span>
                        <X size={12} weight="bold" />
                      </Badge>
                    </motion.div>
                  ))}
                </AnimatePresence>
              </div>
            </div>
          )}
        /> */}
      </div>
    </SectionDialog>
  );
};
